import ApplicationTab from "./ApplicationTab";

export default ApplicationTab;